





























































































































































import { isEmpty, isUndefined } from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { NavigationGuardNext, Route } from 'vue-router'

import { errorNotificationWrapper } from '../../../../logic/helpers/NotificationService'
import Payment from '../../includes/logic/Payment'
import { InvoiceInfo, InvoiceState } from '../../includes/types/Shared/InvoiceInfo.types'
import PaymentStatusDelegatedIcon from './components/PaymentStatusDelegatedIcon.vue'

Vue.filter('date', (value:any, fullDate = false) => {
  const data = new Date(String(value))
  if (fullDate) return data.toLocaleString()
  return data.toLocaleDateString()
})

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    PaymentStatusDelegatedIcon,
  },
  methods: {
    isEmpty,
  },
  data() {
    return {
      InvoiceState
    }
  }
})
export default class PaymentStatus extends Vue {
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext): void {
    if (isUndefined(to.query.invoiceData)) {
      next({ name: 'error_404' })
    }
    next()
  }

  invoiceData = ''

  invoice: InvoiceInfo | null = null

  companyDetails = {
    name: this.$store.state.AdminTemplate.applicationConfig.meta.projectName,
    siteUrl: this.$store.state.AdminTemplate.applicationConfig.meta.projectDomain,
  }

  loading = false

  async mounted(): Promise<void> {
    this.invoiceData = this.$route.query.invoiceData as string
    this.loading = true
    try {
      const response = await Payment.getPayInfo(this.invoiceData)
      this.invoice = response.data.invoice
    } catch (error) {
      errorNotificationWrapper(this.$t('error').toString(), error)
    } finally {
      this.loading = false
    }
  }
}
